import i18n from "i18next";
import { useTranslation } from "react-i18next";

export const useClientTranslation = () => {
  const { t } = useTranslation();

  const getClientTranslation = (key: string, selectedClient: string) => {
    return i18n.exists(`${key}.${selectedClient}`) ? t(`${key}.${selectedClient}`) : t(`${key}.default`);
  };

  return getClientTranslation;
};
